import React from "react";

import { Link, useParams } from "react-router-dom";

import { formatPercent } from "utils/format";
import PanelSection from "components/PanelSection";

import { makeFilter } from "utils/filter";
import Grid, { MsCell, NumberCell } from "components/Grid";
import { useQueryStringSearch } from "components/QueryStringSearch";
import { useRoutes } from "utils/routes";
import { ServerGroupQueryPerformanceQuery } from "../gql/Query.generated";

type SummaryType =
  ServerGroupQueryPerformanceQuery["getQueryOverviewStatsByDatabaseGroup"][number];

function ServerGroupQueryOverviewTable({ data }: { data: SummaryType[] }) {
  const { serverGroupId } = useParams();
  const { serverGroupQueries } = useRoutes();
  const [searchTerm, SearchInput] = useQueryStringSearch("q");

  const tableData = data.map((inputData: SummaryType) => {
    return {
      ...inputData,
      databaseName: inputData.databaseGroup?.datname,
    };
  });

  const gridData = tableData.filter(makeFilter(searchTerm, "databaseName"));

  return (
    <>
      <PanelSection className="flex justify-end">
        <SearchInput />
      </PanelSection>
      <Grid
        striped
        defaultSortBy="queriesPerSecond"
        data={gridData}
        columns={[
          {
            field: "databaseName",
            header: "Database",
            width: "minmax(30%,1fr)",
            renderer: function DatabaseNameCell({ fieldData, rowData }) {
              if (rowData.databaseGroup?.hidden) {
                return fieldData;
              }
              return (
                <Link to={serverGroupQueries(serverGroupId, fieldData)}>
                  {fieldData}
                </Link>
              );
            },
          },
          {
            field: "avgTime",
            header: "Avg Time (ms)",
            width: "minmax(12%,120px)",
            style: "number",
            defaultSortOrder: "DESC",
            renderer: MsCell,
          },
          {
            field: "queriesPerSecond",
            header: "Queries / Second",
            width: "minmax(12%,120px)",
            style: "number",
            defaultSortOrder: "DESC",
            nullValue: "n/a",
            renderer: NumberCell,
          },
          {
            field: "pctOfTotalIo",
            header: "% of All I/O",
            width: "minmax(12%,120px)",
            style: "number",
            defaultSortOrder: "DESC",
            nullValue: "n/a",
            renderer: function PctOfTotalIoCell({ fieldData }) {
              return formatPercent(fieldData / 100.0);
            },
          },
          {
            field: "pctOfTotal",
            header: "% of All Runtime",
            width: "minmax(12%,120px)",
            style: "number",
            defaultSortOrder: "DESC",
            renderer: function PctOfTotalCell({ fieldData }) {
              return formatPercent(fieldData / 100.0);
            },
          },
        ]}
      />
    </>
  );
}

export default ServerGroupQueryOverviewTable;
